import type { Tag } from 'src/types/dashboard';
import { ENLARGE_VALUE } from 'src/components/dashboard/DashboardPage/widgets/TagCloudWidget/TagCloud/constants';

/**
 * Description: Returns the amount of zero points of the average value of the frequency
 * from tags in case the average value is smaller than one.
 */
export const getAverageZeroPoints = (tags: Tag[]) => {
  const frequencyAverage =
    tags.reduce((acc: number, { frequency }) => acc + frequency, 0) /
    tags.length;
  if (frequencyAverage >= 1) return 0;

  let zeroPoints = 0;
  const frequencySplitDecimal = frequencyAverage.toString().split('.');
  if (frequencySplitDecimal.length > 1) {
    const decimalSplit = frequencySplitDecimal[1].split('0');
    let [currentValue, index] = ['', 0];
    while (!currentValue || index > decimalSplit.length) {
      currentValue = decimalSplit[index];
      index++;
    }
    zeroPoints = index - 1;
  }
  return zeroPoints;
};

export const enlargeValue = (value: number, zeroPoints: number) =>
  Math.abs(value) * Math.pow(10, zeroPoints + ENLARGE_VALUE);
